import axios from 'axios'
import { useToast } from 'vue-toastification';

const toast = useToast();

function parseAlarmValue(value) {
  if (value === null) {
    return null;
  }
  return parseFloat(parseFloat(value).toFixed(3));
}

export const alarm = {
  namespaced: true,
  state: {
    alarm_set: [],
    original_alarm_set: [],
    alarm_history: [],
    alarm_type_options: [],
    alarm_action_type_options: [],

    url_get_user_sensor: 'alarm/getSensorUsersContact/',
    url_acknowledge_alarm: 'alarm/acknowledge/',
    url_save_alarms: 'alarm/saveAll'
  },

  mutations: {
    setAlarmSet(state, data) {
      data.forEach(alarm => {
        alarm.alarm_set_point = parseAlarmValue(alarm.alarm_set_point);
        if (alarm.alarm_type_id == 3) {
          alarm.alarm_set_point = Math.abs(alarm.alarm_set_point);
        }
        alarm.alarm_set_point_2 = parseAlarmValue(alarm.alarm_set_point_2);
        alarm.error = false;
        alarm.status = 'existing';
      });
      state.alarm_set = data;
      state.original_alarm_set = structuredClone(data);
    },
    setAlarmHistory(state, data) {
      state.alarm_history = data;
    },
    setAlarmCountActive(state, data) {
      state.alarm_count_active = data;
    },
    setAlarmType(state, data) {
      let alarm = state.alarm_set.find(i => i.alarm_id === data.id);
      alarm.alarm_type_id = data.alarm_type_id;
      this.commit('alarm/updateAlarmStatus', { id: data.id, status: 'updated' });
    },
    setAlarmTypeOptions(state, data) {
      state.alarm_type_options = data;
    },
    setAlarmActionType(state, data) {
      let alarm = state.alarm_set.find(i => i.alarm_id === data.id);
      alarm.alarm_action_type_id = data.alarm_action_type_id;
      this.commit('alarm/updateAlarmStatus', { id: data.id, status: 'updated' });
    },
    setAlarmActionTypeOptions(state, data) {
      state.alarm_action_type_options = data;
    },
    addNewAlarm(state, data) {
      state.alarm_set.push(data);
    },
    updateAlarm(state, data) {
      let alarm = state.alarm_set.find(i => i.alarm_id === data.id);
      Object.assign(alarm, data);
      this.commit('alarm/updateAlarmStatus', { id: data.id, status: 'updated' });
    },
    updateAlarmStatus(state, data) {
      let alarm = state.alarm_set.find(i => i.alarm_id === data.id);
      if (!alarm) return;
      if (data.status === 'deleted') {
        alarm.status = 'deleted';
        return;
      }
      if (alarm.status === 'new') {
        return;  // no need to update status if alarm is new and not deleted
      }
      // Check if alarm has changed
      let original_alarm = state.original_alarm_set.find(i => i.alarm_id === data.id);
      if (!original_alarm) {
        alarm.status = data.status;
        return;
      }
      // eslint-disable-next-line no-unused-vars
      let { status: alarmStatus, error: alarmError, ...alarmNoStatus } = alarm;
      // eslint-disable-next-line no-unused-vars
      let { status: originalAlarmStatus, error: originalAlarmError, ...originalAlarmNoStatus } = original_alarm;
      if (JSON.stringify(alarmNoStatus) === JSON.stringify(originalAlarmNoStatus)) {
        alarm.status = 'existing';
        return;  // no need to update status if alarm hasn't changed
      }
      alarm.status = data.status;
    },
    setSelectedNotifications(state, data) {
      let alarm = state.alarm_set.find(i => i.alarm_id === data.id);
      alarm.selected_notify = data.selected_notify;
      if (alarm.status === 'new') {
        return;  // only update notifications for existing alarms
      }
      this.dispatch('alarm/SaveSelectedNotifications', { alarm_id: data.id, selected_notify: data.selected_notify });
    },
    setHysteresis(state, data) {
      let alarm = state.alarm_set.find(i => i.alarm_id === data.id);
      alarm.alarm_set_point_2 = parseAlarmValue(data.hysteresis);
      this.commit('alarm/updateAlarmStatus', { id: data.id, status: 'updated' });
    },
    setSetPoint(state, data) {
      let alarm = state.alarm_set.find(i => i.alarm_id === data.id);
      let value = data.alarm_set_point;
      if (alarm.alarm_type_id == 3) {
        value = Math.abs(value);
      }
      alarm.alarm_set_point = value;
      this.commit('alarm/updateAlarmStatus', { id: data.id, status: 'updated' });
    },
    setRegister(state, data) {
      let alarm = state.alarm_set.find(i => i.alarm_id === data.id);
      alarm.alarm_register = data.alarm_register.toString();
      this.commit('alarm/updateAlarmStatus', { id: data.id, status: 'updated' });
    },
    removeAlarmsBySensorId(state, sensor_id) {
      // Mark as deleted all alarms for the given sensor_id
      state.alarm_set.forEach(alarm => {
        if (alarm.sensor_id == sensor_id) {
          alarm.status = 'deleted';
        }
      });
    },
    removeAlarmsByRegister(state, { sensor_id, register }) {
      state.alarm_set.forEach(alarm => {
        if (alarm.sensor_id == sensor_id && alarm.alarm_register == register) {
          alarm.status = 'deleted';
        }
      });
    },
    resetAlarmSet(state) {
      state.alarm_set = structuredClone(state.original_alarm_set);
    },
    setAlarmError(state, data) {
      let alarm = state.alarm_set.find(i => i.alarm_id == data.id);
      alarm.error = data.error;
    },
    clearAlarmError(state, data) {
      let alarm = state.alarm_set.find(i => i.alarm_id == data.id);
      alarm.error = false;
    }
  },

  actions: {
    async fetchAlarms({ rootState, commit }) {
      let gatewayId = rootState.gateway.id;
      if (!gatewayId) return;
      let url = `${rootState.settings.api_base}alarm/${gatewayId}`;

      try {
        let rs = await axios.get(url);

        // API now handles data transformations, so no need for client-side inverse math
        let fixedAlarms = rs.data.AlarmSet;

        // Check if the gateway hasn't changed while we were fetching
        if (rootState.gateway.id === gatewayId) {
          commit('setAlarmSet', fixedAlarms);
          commit('setAlarmHistory', rs.data.AlarmHistory);
          commit('setAlarmCountActive', rs.data.AlarmCountActive);
          commit('setAlarmTypeOptions', rs.data.AlarmTypeOptions);
          commit('setAlarmActionTypeOptions', rs.data.AlarmActionTypeOptions);
        }

      } catch (err) {
        console.error('Failed to retrieve alarm(s).  Error was ');
        console.error({ err });
      }
    },

    async AcknowledgeAlarm({ rootState, commit, state, dispatch }, payload) {
      let url = rootState.settings.api_base + state.url_acknowledge_alarm + payload.alarm_data_id;
      try {
        let rs = await axios.get(url)
        // console.log(rs);
        commit('apgList/setList', { listType: "alarm_history", data: rs.data.AlarmHistory }, { root: true });
        commit('apgList/setList', { listType: "alarm_count_active", data: rs.data.AlarmCountActive }, { root: true });

        // Refresh alarms
        await dispatch('fetchAlarms');
      } catch (err) {
        console.error('Failed to get reading control function ', err)
      }
    },

    async AddNewAlarm({ rootState, state, commit, dispatch }) {
      try {
        // check user type
        if (rootState.gateway.paid_tier == 1) {
          toast.info('Free subscriptions cannot add alarms. Please contact APG Sales team to upgrade your gateway subscription.');
          return;
        }

        let sensor_id = rootState.sensor.id;
        let currentAlarmIds = state.alarm_set.map(alarm => alarm.alarm_id);
        let tempAlarmId;
        do {
          tempAlarmId = Math.floor(Math.random() * 100000);
        } while (currentAlarmIds.includes(tempAlarmId));

        // The sensor is preselected, so the sensor dropdown never fires a change to load the contacts
        let toWhom = sensor_id ? (await dispatch('fetchNotificationOptions', sensor_id)) || [] : [];

        let json = {
          sensor_id: sensor_id,
          alarm_id: -tempAlarmId,
          sensor_address: '0',
          alarm_type_id: '0',
          alarm_set_point_2: undefined,
          alarm_register: "0",
          register_type_id: "0",
          alarm_set_point: "0",
          toWhom: toWhom,
          status: "new",
        }
        commit('addNewAlarm', json);
      } catch (err) {
        console.error('Failed to add new alarm, could not find sensor info ', err)
      }
    },

    async SaveAlarms({ state, rootState, commit, dispatch }, force = false) {
      const hasChanges = state.alarm_set.some(a => a.status !== 'existing');
      if (!force && !hasChanges) {
        return;
      }
      let url = rootState.settings.api_base + state.url_save_alarms;
      let gatewayId = rootState.gateway.id;

      try {
        await axios.post(url, {
          alarms: state.alarm_set,
          gateway_id: gatewayId
        });
        // refresh alarms, pending messages, and info overview
        await dispatch('fetchAlarms');
        await dispatch('gateway/findQueuedMessages', { id: gatewayId }, { root: true });
        await dispatch('gateway/findInfoOverview', { id: gatewayId }, { root: true });
        await commit('MyView/addGatewayPendingMessages', { gatewayId: gatewayId }, { root: true });
        toast.success('Changes to alarms message queue have been saved!');
      } catch(err) {
        // the API rejects set points the register can't reach (eg more than the tank holds) and saves nothing
        let rangeErrors = err.response?.status === 400 ? err.response.data?.errors : null;
        if (Array.isArray(rangeErrors)) {
          rangeErrors.forEach(e => {
            commit('setAlarmError', { id: e.alarm_id, error: e.message });
            toast.error(e.message);
          });
          return;
        }
        console.error('Saving the alarm has failed. The error was', err);
        toast.error('Unable to queue alarms message. Please try again later.');
      }
    },

    async fetchNotificationOptions({ rootState, state }, sensorId) {
      let url = rootState.settings.api_base + state.url_get_user_sensor + sensorId;
      // console.log('url is', url);
      try {
        let rs = await axios.get(url);
        return rs.data;
      } catch (e) {
        console.error('Failed to fetch notification options', e);
        toast.error('Failed to fetch notification contacts');
      }
    },

    async SaveSelectedNotifications({ rootState }, payload) {
      let url = `${rootState.settings.api_base}alarm/notifications/${payload.alarm_id}`;
      try {
        await axios.post(url, { selected_notify: payload.selected_notify });
        toast.success('Alarm notifications saved!');
      } catch (err) {
        console.error('Failed to save notifications', err);
        toast.error('Failed to save alarm notifications');
      }
    }
  },

  getters: {
    alarm_set: state => state.alarm_set,
    alarm_history: state => state.alarm_history,
    alarm_count_active: state => state.alarm_set.filter(alarm => alarm.active != null).length,
    setAlarmStatus: state => id => state.alarm_set.find(i => i.alarm_id === id).status,
    selectedNotify: state => id => state.alarm_set.find(i => i.alarm_id === id).selected_notify,
    alarm: state => id => state.alarm_set.find(i => i.alarm_id === id),
    toWhom: state => id => state.alarm_set.find(i => i.alarm_id === id).toWhom,
    anyAlarmError: state => state.alarm_set.some(alarm => alarm.error),
    registerExtraMath: (state, getters, rootState) => {
      const registerAttributes = rootState?.apgList?.List?.register_attribute;
      if (!registerAttributes) return null;
      const extraMathAttr = registerAttributes.find(attr => attr.attribute_key === 'Register Extra Math');
      return extraMathAttr ? extraMathAttr.attribute_value : null;
    }
  }
}